
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const backgroundImages = [
  "https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80", // Earth/space
  "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80", // Legal scales of justice
  "https://images.unsplash.com/photo-1523805009345-7448845a9e53?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80", // African cityscape Nairobi
  "https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80", // African landscape
  "https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80", // African professionals in tech
  "https://images.unsplash.com/photo-1505664194779-8beaceb93744?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"  // Law library books
];

const lowResUrl = (url: string) =>
  url.replace(/w=\d+/, 'w=40').replace(/q=\d+/, 'q=20');

const HeroSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState<boolean[]>(
    () => backgroundImages.map(() => false)
  );

  useEffect(() => {
    backgroundImages.forEach((src, index) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        setLoadedImages((prev) => {
          const next = [...prev];
          next[index] = true;
          return next;
        });
      };
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative text-white overflow-hidden">
      {/* Animated background images with progressive loading */}
      <div className="absolute inset-0 bg-muted">
        {backgroundImages.map((image, index) => (
          <React.Fragment key={index}>
            {/* Low-res blurred placeholder */}
            <div
              className={`absolute inset-0 bg-cover bg-center scale-110 blur-xl transition-opacity duration-700 ${
                index === currentImageIndex ? 'opacity-100' : 'opacity-0'
              }`}
              style={{ backgroundImage: `url('${lowResUrl(image)}')` }}
            />
            {/* Full-res image, fades in once loaded */}
            <div
              className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${
                index === currentImageIndex && loadedImages[index] ? 'opacity-100' : 'opacity-0'
              }`}
              style={{ backgroundImage: `url('${image}')` }}
            />
          </React.Fragment>
        ))}
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-28 md:py-40">
        <div className="flex flex-col items-center text-center">
          <h1 className="text-5xl md:text-7xl mb-4 leading-tight text-white drop-shadow-lg" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500, letterSpacing: '-0.01em' }}>
            Leading Tech and Commercial Law
            <br />
            <span className="text-secondary drop-shadow-lg">Commentary in Africa</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-white drop-shadow-lg">
            Expert commentary at the intersection of technology, commerce, and the law
          </p>
          
          <Link 
            to="/about-us#areas-of-expertise"
            className="bg-secondary hover:bg-secondary/90 text-white px-8 py-3 rounded-full font-semibold text-lg transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
          >
            Our Expertise
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
